import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Communications = forwardRef<SVGSVGElement, SvgIconProps>(
  function Communications(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M21.951 10.743l-2.448-4.901A1.529 1.529 0 0018.133 5H5.843c-.587 0-1.101.322-1.37.842l-2.4 4.9A.669.669 0 002 11.04v6.559C2 18.935 3.053 20 4.375 20h15.25C20.947 20 22 18.935 22 17.599v-6.535c0-.124-.025-.223-.049-.322zM5.672 6.436c.049-.074.098-.124.196-.124H18.18c.098 0 .146.05.195.124l1.958 3.96h-4.307c-.294 0-.587.222-.636.52-.025.099-.612 2.87-3.378 2.87s-3.354-2.722-3.378-2.87c-.074-.298-.319-.52-.637-.52H3.714l1.958-3.96z" />
      </SvgIcon>
    )
  },
)

export default Communications
